<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1200"
  >
    <template v-slot:activator="{ on:dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on:tooltip }">
          <v-btn
            icon
            v-on="{...dialog,...tooltip}"
          >
            <v-icon color="primary">
              mdi-calculator
            </v-icon>
          </v-btn>
        </template>
        <span>Compute Cycle</span>
      </v-tooltip>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Computation"
      text="Preparing for Computation"
      class="mb-0"
      :loading="loading"
    > 
      <v-container v-if="dialog && !loading">
        <v-row no-gutters>
          <v-col cols="6">
            <v-text-field
              v-model="searchInput"
              placeholder="Filter employee by name"
              append-icon="search"
              label="Search Employee"
              hide-no-data
              hide-selected
            />
          </v-col>
        </v-row>

        <v-row
          v-if="endedCompanyEmployeeCount > 0"
          no-gutters
          class="font-weight-bold"
        >
          <div>
            <v-fade-transition>
              <v-icon
                :style="{
                  animationDuration: `0.6s`
                }"
                color="red"
                class="mb-1 v-avatar--metronome white--text"
                size="x-large"
              >
                mdi-alert-circle
              </v-icon>
            </v-fade-transition>
            <span 
              class="ml-1 red--text font-16"
            >
              Kindly note that there {{ endedCompanyEmployeeCount > 1 ? 'are ' + endedCompanyEmployeeCount + ' employees that have ' : 'is ' + endedCompanyEmployeeCount + ' employee that has ' }} end date. Please make sure the list is correct before proceed for computation.
            </span>
          </div>
        </v-row>
        
        <v-row class="font-weight-bold font-16 border-bottom-light-grey">
          <v-col cols="4">
            Payroll Company
          </v-col>
          <v-col cols="5">
            Name
          </v-col>
          <v-col cols="3">
            Status
          </v-col>
        </v-row>
 
        <v-row
          v-for="(employee,index) in filteredEmployees"
          :key="employee.id"
          no-gutters
          :class="{'alternate-row':index % 2 === 0 }"
          class="font-weight-bold"
        >
          <v-col
            cols="4"
            class="ma-auto"
          >
            {{ employee.company_employee.company.name }}
          </v-col>

          <v-col
            cols="5"
            class="ma-auto"
            :class="employee.company_employee.end_date ? 'red--text ma-auto' : 'ma-auto'"
          >
            {{ employee.company_employee.end_date ? employee.company_employee.employee.person.name + ' (End date: ' + $moment(employee.company_employee.end_date).format('D MMM YYYY') + ')' : employee.company_employee.employee.person.name }}
          </v-col>

          <v-col
            cols="3"
            class="ma-auto"
          >
            <v-overflow-btn
              v-model="employee.status"
              class="ma-0 dropdownHeight"
              dense
              :items="status"
              flat
              hide-no-data
              hide-selected
            />
          </v-col>
        </v-row>
      </v-container>
      
      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"           
          @click="submitForm"
        >
          Compute
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      payrollCycleTransaction: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        progressing: false,
        dialog: null,
        loading: false,
        payrollCycleEmployees: [],
        status: [
          'COMPUTATION',
          'STOP SALARY',
          'HOLD SALARY',
        ],
        searchInput: '',
        endedCompanyEmployeeCount: 0,
      }
    },
    computed: {
      filteredEmployees () {
        let _this = this
        _this.searchInput = _this.searchInput.trim()

        return this.payrollCycleEmployees.filter(function (employee) {
          return ((employee.company_employee.employee.person || {}).name || '').toLowerCase().indexOf(_this.searchInput.toLowerCase()) !== -1
        })
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData()

        this.loading = true

        this.$api.payrollCycleTransactions().list(this.payrollCycleTransaction.id)
          .then(res => {
            this.payrollCycleEmployees = _.orderBy(res.data, ['company_employee.company.name', 'company_employee.employee.person.name'], ['asc', 'asc'])
            
            this.payrollCycleEmployees.map(employee => {
              employee.status = 'COMPUTATION'
            })

            this.endedCompanyEmployeeCount = this.payrollCycleEmployees.filter(ce => ce.company_employee.end_date).length

            this.loading = false
          })
      },
    },
    methods: {  
      submitForm () {
        this.setProgressing(true)
    
        this.$api.payrollCycleTransactions().compute(this.payrollCycleTransaction.id, this.prepareFormData())
          .then(res => {
            if (res.status === 200 || res.status === 201) {
              this.$emit('created')       
              this.$emit('payrollComputed')       
              this.$snack({ message: res.data.status })
              this.setProgressing(false)

              this.dialog = false    
            }
          }).catch(() => {
            this.setProgressing(false)
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        let data = []

        this.payrollCycleEmployees.map(employee => {
          data.push({ payroll_cycle_employee_id: employee.id, company_employee_uid: employee.company_employee_uid, status: employee.status })
        })

        return {
          data: data,
        }
      }, 
    },
  }
</script>

<style scoped>
.font-16{
  font-size:16px;
}

.border-bottom-light-grey{
  border-bottom:1px solid #e6e6e6;
}

.dropdownHeight >>> .v-input__control .v-input__slot{
  height:26px !important;
}

.dropdownHeight >>> .v-input__control{
  height:26px !important;
}

.dropdownHeight >>> .v-input__control .v-input__slot::before{
  border:unset !important;
}

.alternate-row{
  background-color: #e6e6e6;
}

@keyframes metronome-example {
  from {
    transform: scale(.5);
  }

  to {
    transform: scale(1);
  }
}

.v-avatar--metronome {
  animation-name: metronome-example;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
</style>
